/**
 * Team details — reveal a member's detail panel from the URL hash.
 *
 * Each name links to `team_page_url/#{slug}`; on the team page we intercept the
 * click, mirror the selection into the hash (so members are linkable and
 * back/forward works), and toggle the matching detail panel. With no hash,
 * nothing is shown.
 */
const ACTIVE = 'is-active'
const slugFromHash = () => decodeURIComponent(location.hash.slice(1))

const activate = (root, slug) => {
  root
    .querySelectorAll('[data-team-detail]')
    .forEach((d) => d.classList.toggle(ACTIVE, d.dataset.teamDetail === slug))
  root
    .querySelectorAll('[data-team-trigger]')
    .forEach((t) => t.classList.toggle(ACTIVE, t.dataset.teamTrigger === slug))
}

const setupTeam = (root) => {
  root.querySelectorAll('[data-team-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      const slug = trigger.dataset.teamTrigger
      // No panel here (e.g. block on another page) → let the link navigate.
      if (!root.querySelector(`[data-team-detail="${slug}"]`)) return
      e.preventDefault()
      if (slugFromHash() !== slug) history.pushState(null, '', `#${slug}`)
      activate(root, slug)
    })
  })

  activate(root, slugFromHash())
  window.addEventListener('hashchange', () => activate(root, slugFromHash()))
}

export const initTeamDetails = (root = document) =>
  root.querySelectorAll('[data-team]').forEach(setupTeam)

initTeamDetails()
